import { useLocation } from "react-router-dom";
import { useUseCasePathState } from "../../components/UseCaseNavigator";
import { useQuestionnaires } from "../../hooks/useQuestionnaires";
import { useUseCase } from "../../hooks/useUseCases";
import { UseCaseWizardLoader } from "../../layouts/skeleton-loaders/UseCaseWizardLoader";
import { UseCaseWizard } from "../../organisms/registry/UseCaseWizard";

export default function QuestionnaireWizard() {
  const location = useLocation();
  const { data: pathData } = useUseCasePathState(location.state, location.pathname);
  const { useCaseId } = pathData!;
  const { data, isLoading } = useUseCase(useCaseId);

  const { data: questionnaires, isLoading: isLoadingQuestionnaire } = useQuestionnaires({
    "metadata_internal_wizard[]": "USE_CASE",
  });
  const template = data?.template
    ? data.template
    : questionnaires && questionnaires.results && questionnaires.results.length > 0
    ? questionnaires.results[0].id
    : "";
  return data && !isLoading && !isLoadingQuestionnaire && template !== "" ? (
    <UseCaseWizard useCase={data} templateId={template} />
  ) : (
    <UseCaseWizardLoader />
  );
}
